/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// eslint-disable-next-line
function cartUpsellProducts(opts) {
  const config = {
    dom: {
      parent: 'cartItems',
      cartItem: 'js-cart-item',
      upsellWrapper: 'js-upsell-wrapper',
      upsellATC: 'js-upsell-atc',
      upsellProducts: 'js-upsell-products',
      upsellCancel: 'js-upsell-cancel',
      upsellData: 'upsellData',
      showBtn: 'js-acc-btn',
      selectedOptions: 'js-selected-value',
      valueList: 'js-select-list',
      collectionToolbar: 'js-collection-toolbar',
      form: 'js-filter-form',
      submitBtn: 'filter-form__submit-btn',
      filterBtn: 'js-filters-btn',
      sortBtn: 'js-sort-btn',
      collectionBar: 'js-colllection-bar',
      sort_trigger: 'filterSortTrigger',
      sort_options: 'filterSortOptions',
      sort_option: '.js-sort-option',
      toolbarWrapper: 'CollectionToolbarWrapper',
      upsellImageContainer: 'js-upsell-images',
      upsellProduct: 'js-upsell-product',
    },
    cls: {
      hide: 'hide',
      plus: 'plus',
      minus: 'minus',
      closed: 'closed',
      visible: 'visible',
    },
  };
  const c = _.extend(config, opts);

  const $parent = document.getElementById(c.dom.parent);
  const $upsellData = document.getElementById(c.dom.upsellData);
  const $form = document.querySelector(`.${c.dom.form}`);
  const $filterBtn = document.querySelector(`.${c.dom.filterBtn}`);
  const $sortTrigger = document.getElementById(c.dom.sort_trigger);
  const $sortBtn = document.querySelector(`.${c.dom.sortBtn}`);
  const $sortOptions = document.querySelectorAll(c.dom.sort_option);
  const $toolbarWrapper = document.getElementById(c.dom.toolbarWrapper);

  /**
   * Init
   */
  function init() {
    setUpCollectionFilters();
    if ($parent) {
      addEvents();
      removeUpsellsWithNoParent();
      showUpsellImage();
    }

    if ($sortTrigger && $sortOptions[0]) enableSortProducts();
  }

  function showUpsellImage() {
    const $upsellProducts = document.querySelectorAll(`.${c.dom.upsellProduct}`);

    $upsellProducts.forEach(($upsellProduct) => {
      $upsellProduct.addEventListener('mouseover', (e) => {
        const $target = e.target.closest(`.${c.dom.upsellProduct}`);
        const $targetWrapper = $target.closest(`.${c.dom.upsellWrapper}`);
        const $upsellImageContainer = $targetWrapper.querySelectorAll(`.${c.dom.upsellImageContainer}`);

        $upsellImageContainer.forEach(($container) => {
          if ($target.dataset.imgsrc === $container.dataset.imgsrc) {
            _.removeClass($container, c.cls.hide);
          }
        });
      });

      $upsellProduct.addEventListener('mouseout', (e) => {
        const $target = e.target.closest(`.${c.dom.upsellProduct}`);
        const $targetWrapper = $target.closest(`.${c.dom.upsellWrapper}`);
        const $upsellImageContainer = $targetWrapper.querySelectorAll(`.${c.dom.upsellImageContainer}`);

        $upsellImageContainer.forEach(($container) => {
          if ($target.dataset.imgsrc === $container.dataset.imgsrc) {
            _.addClass($container, c.cls.hide);
          }
        });
      });
    });
  }

  function setUpCollectionFilters() {
    _.addEvent({
      id: c.dom.collectionToolbar,
      event: 'click',
      fn: () => {
        $form.classList.add(c.cls.closed);
        if ($filterBtn) {
          $filterBtn.classList.add(c.cls.closed);
        }
        if ($sortBtn.classList.contains(c.cls.closed)) {
          _.removeClass($sortBtn, c.cls.closed);
          _.removeClass($sortBtn.parentNode, c.cls.closed);
        } else {
          _.addClass($sortBtn, c.cls.closed);
          _.addClass($sortBtn.parentNode, c.cls.closed);
        }
      },
      className: c.dom.sortBtn,
    });

    _.addEvent({
      id: c.dom.collectionToolbar,
      event: 'click',
      fn: () => {
        _.addClass($sortBtn, c.cls.closed);
        _.addClass($sortBtn.parentNode, c.cls.closed);
        if ($form.classList.contains(c.cls.closed)) {
          $form.classList.remove(c.cls.closed);
          $filterBtn.classList.remove(c.cls.closed);
        } else {
          $form.classList.add(c.cls.closed);
          $filterBtn.classList.add(c.cls.closed);
        }
      },
      className: c.dom.filterBtn,
    });

    _.addEvent({
      id: c.dom.toolbarWrapper,
      event: 'change',
      className: c.dom.filter,
      fn: (e) => {
        const $btn = document.querySelector(`.${c.dom.submitBtn}`);
        e.stopPropagation();
        $btn.disabled = false;
      },
    });
  }

  function enableSortProducts() {
    $sortOptions.forEach(($option) => {
      $option.addEventListener('click', (e) => {
        const { value } = e.target;
        setUrlParam('sort_by', value);
        window.location.reload();
      });
    });
  }

  function setUrlParam(key, value) {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, value);
    const newPath = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState(null, '', newPath);
  }

  /**
   * Add events
   */
  function addEvents() {
    _.addEvent({
      id: $parent,
      event: 'click',
      fn: addToCart,
      className: c.dom.upsellATC,
    });

    _.addEvent({
      id: $parent,
      event: 'click',
      fn: showUpsells,
      className: c.dom.upsellCancel,
    });

    _.addEvent({
      id: $parent,
      event: 'click',
      fn: showUpsells,
      className: c.dom.showBtn,
    });
  }

  /**
   * Toggle upsell accordion
   * @param {object} e - click event
   */
  function showUpsells(e) {
    const $target = e.target;
    const $upsellWrapper = _.parents($target, `.${c.dom.upsellWrapper}`)[0];
    const $upsellProducts = $upsellWrapper.querySelector(`.${c.dom.upsellProducts}`);
    const $showBtn = $upsellWrapper.querySelector(`.${c.dom.showBtn}`);

    if (!_.hasClass($upsellProducts, c.cls.hide)) {
      _.addClass($upsellProducts, c.cls.hide);
      _.removeClass($showBtn, c.cls.minus);
    } else {
      _.removeClass($upsellProducts, c.cls.hide);
      _.addClass($showBtn, c.cls.minus);
    }
  }

  /**
   * Returns variant id of the upsell product to add for this line item
   * @param {string} key - line item key of cart item
   */
  function getCheckedValue(key) {
    const checked = document.querySelector(`input[name="cart-item-${key}"]:checked`);
    if (!checked) return false;
    return checked.value;
  }

  /**
   * Add to cart
   * @param {object} e - click event
   */
  function addToCart(e) {
    const $target = e.target;
    const $upsellWrapper = _.parents($target, `.${c.dom.upsellWrapper}`)[0];
    const $cartItem = $upsellWrapper.previousElementSibling;
    const parentKey = $cartItem.dataset.key;
    const variantId = getCheckedValue(parentKey);
    if (variantId) {
      // trying to pass custom data for later formatting
      const upsellData = {
        id: variantId,
        quantity: 1,
        properties: {
          _parentKey: parentKey,
        },
      };

      const url = `${window.routes.cartAddUrl}.js`;

      _.ajax({
        data: JSON.stringify(upsellData),
        contentType: 'application/json',
        error: (error) => { console.log('error', error); },
        success: () => {
          // cart refresh
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        },
        type: 'POST',
        url,
      });
    }
  }

  /**
   * Remove upsells with no parent product
   */
  function removeUpsellsWithNoParent() {
    if (!$upsellData) return;

    const {
      upsellItemsArray,
      upsellItemsHasParentArray,
    } = $upsellData.dataset;

    const upsellItems = JSON.parse(upsellItemsArray);
    const upsellItemsWithParents = JSON.parse(upsellItemsHasParentArray);

    const upsellItemsToRemove = upsellItems.filter((i) => !upsellItemsWithParents.includes(i));

    if (upsellItemsToRemove.length) {
      const updates = {};
      upsellItemsToRemove.forEach((item) => {
        updates[item] = 0;
      });

      const url = `${window.routes.cartUrl}/update.js`;
      _.ajax({
        data: JSON.stringify({ updates }),
        contentType: 'application/json',
        error: (error) => { console.log('error', error); },
        success: () => {
          // cart refresh
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        },
        type: 'POST',
        url,
      });
    }
  }

  return init();
}
